var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArchiveError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0593ff;}.cls-2{fill:#d8e1ef;}.cls-3{fill:#0e6ae0;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Folder Warning",
    id: "Folder_Warning"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.83,6.45l-1.4-2.11A3,3,0,0,0,10.93,3H4A2,2,0,0,0,2,5V7A1,1,0,0,0,3,8H14a1,1,0,0,0,.88-.53A1,1,0,0,0,14.83,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,6H2V20a2,2,0,0,0,2,2H23a1,1,0,0,0,1-1V8A2,2,0,0,0,22,6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23,
    cy: 22,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23,23a1,1,0,0,1-1-1V19a1,1,0,0,1,2,0v3A1,1,0,0,1,23,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23,26a1,1,0,0,1,0-2,1,1,0,0,1,1,1A1,1,0,0,1,23,26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchiveError);
export default __webpack_public_path__ + "static/media/icon-archive-error.be1e48a94340aa6403d57cea7e1d0964.svg";
export { ForwardRef as ReactComponent };